import {UseFormSetValue} from "react-hook-form";
import {
    CreateCorrespondentInterface
} from "../../../../customer/correspondent/create/interface/CreateCorrespondentInterface";
import {BasicClientInfoType, SearchAccountType} from "../../../../customer/correspondent/detail/interface";
import {useReadAccountBasicInfo} from "../../../../order/orders/create/hooks/useReadAccountBasicInfo";
import {useReadAccountShipmentInfo} from "../../../../order/orders/create/hooks/useReadAccountShipmentInfo";
import {SearchContactType} from "../../../../customer/contact/interface";
import {OrdersDetailType} from "../../detail/interface";
import {OrdersCreateSubjectType, OrdersCreateType} from "../interface";
import {PcsSubjectElementType} from "../../../../purchase/pcs/detail/interface";
import {ordersCreateSubjectElementInit} from "../state";
import moment from "moment";

export default function useSetOrdersValue() {
    const {mutateAsync: mutateAsyncReadAccountBasicInfo} = useReadAccountBasicInfo()
    const {mutateAsync: mutateAsyncReadAccountShipmentInfo} = useReadAccountShipmentInfo()

   function adjustToValidDateWithMoment(dateString: string) {
  if (!dateString) return "";

  const m = moment(dateString, "YYYY-MM-DD", true);

  // 유효한 날짜면 그대로 반환
  if (m.isValid()) {
    return dateString;
  }

  // 유효하지 않다면 연/월/일 분해
  const [year, month, day] = dateString.split("-").map(Number);

  // 해당 월의 말일
  const lastDay = moment(`${year}-${month}`, "YYYY-MM").daysInMonth();

  // 말일로 보정
  return moment(
    `${year}-${month}-${Math.min(day, lastDay)}`,
    "YYYY-MM-DD"
  ).format("YYYY-MM-DD");
    }
    
    const setContact = (item: SearchContactType, setValue: UseFormSetValue<OrdersCreateType | OrdersDetailType>) => {
        mutateAsyncReadAccountBasicInfo(item.parentcustomeridValue).then(res1 => {
            mutateAsyncReadAccountShipmentInfo({
                accountId: item.parentcustomeridValue,
                chargeName: "",
                name: "",
                defaultContact: "",
                customerCategoryName: "",
                industryName: "",
            }).then(res2 => {
                const basicInfo = res1.result as BasicClientInfoType
                const shipmentInfo = res2.result as SearchAccountType

                // 납품처
                setValue("newLShipToValue", shipmentInfo?.deliveryPlace ?? "")
                setValue("shipToName", shipmentInfo?.deliveryPlaceName ?? "")
                // 매출처
                setValue("newLCustomerValue", shipmentInfo?.salesPlace ?? "")
                setValue("customerName", shipmentInfo?.salesPlaceName ?? "")
                // 고객사
                setValue("newLEnduserValue", basicInfo?.accountId ?? "");
                setValue("enduserName", basicInfo?.name ?? "");
                // 담당자
                setValue("owneridValue", shipmentInfo?.contactPerson ?? "")
                setValue("owningUserName", shipmentInfo?.contactPersonName ?? "")
                // 메모
                setValue("newTxtMemo", shipmentInfo?.memo ?? "");
                // 수주 유형
                setValue("_new_l_order_type_m_value", shipmentInfo?.orderType ?? "");
                // Vat 구분
                setValue("_new_l_vat_value", shipmentInfo?.vatType ?? "");
                // 산업 구분
                setValue("newLIndustryValue", shipmentInfo?.industryCategory ?? "");
                // Application
                setValue("newLApplicationValue", shipmentInfo?.application ?? "");
                // 수신자
                setValue("_new_l_recipient_value", shipmentInfo?.recipient ?? "")
                setValue("recipientName", shipmentInfo?.recipientName ?? "")
                setValue("recipientMobilephone", shipmentInfo?.recipientMobilephone ?? "")
                // 발송지
                setValue("_new_l_address_value", shipmentInfo?.shippingAddress ?? "")
                setValue("address1", shipmentInfo?.address1 ?? "");
                setValue("address2", shipmentInfo?.address2 ?? "");
                setValue("addressName", shipmentInfo?.addressName ?? "");
                // 계산서 담당자
                setValue("newLInvoiceAgentValue", shipmentInfo?.taxInvoicePerson ?? "")
                setValue("taxCharge", shipmentInfo?.taxChargeName ?? "")
                setValue("taxContact", shipmentInfo?.taxChargeMobilePhone ?? "")
                setValue("taxEmail", shipmentInfo?.taxChargeEmailAddress ?? "")
                // 기타사항(거래명세서 비고)
                setValue("newTxtNote", shipmentInfo?.newTxtNote ?? "")
                // 수금메모(세금계산서 비고)
                setValue("newTxtCollection", shipmentInfo?.newTxtCollection ?? "")
                // 마감구분
                setValue("endType", shipmentInfo?.endType ?? "1")
                // 수금예정일
                setValue("newDtEstimatedCollection", adjustToValidDateWithMoment(shipmentInfo?.expectedReceiptDate ?? ""))
            })
        })

        setValue("contactName", item.fullName ?? "")
    }

    const setAccount = (item: CreateCorrespondentInterface, setValue: UseFormSetValue<OrdersCreateType | OrdersDetailType>) => {
        mutateAsyncReadAccountShipmentInfo(item).then(res => {
            if (res.code === "0000") {
                const shipmentInfo = res.result as SearchAccountType

                if (setValue) {
                    // 납품처
                    setValue("newLShipToValue", shipmentInfo?.deliveryPlace ?? "")
                    setValue("shipToName", shipmentInfo?.deliveryPlaceName ?? "")
                    // 매출처
                    setValue("newLCustomerValue", shipmentInfo?.salesPlace ?? "")
                    setValue("customerName", shipmentInfo?.salesPlaceName ?? "")
                    // 고객사
                    setValue("newLEnduserValue", item?.accountId ?? "");
                    setValue("enduserName", item?.name ?? "");
                    // 담당자
                    setValue("owneridValue", shipmentInfo?.contactPerson ?? "")
                    setValue("owningUserName", shipmentInfo?.contactPersonName ?? "")
                    // 메모
                    setValue("newTxtMemo", shipmentInfo?.memo ?? "");
                    // 수주 유형
                    setValue("_new_l_order_type_m_value", shipmentInfo?.orderType ?? "");
                    // Vat 구분
                    setValue("_new_l_vat_value", shipmentInfo?.vatType ?? "");
                    // 산업 구분
                    setValue("newLIndustryValue", shipmentInfo?.industryCategory ?? "");
                    // Application
                    setValue("newLApplicationValue", shipmentInfo?.application ?? "");
                    // 수신자
                    setValue("_new_l_recipient_value", shipmentInfo?.recipient ?? "")
                    setValue("recipientName", shipmentInfo?.recipientName ?? "")
                    setValue("recipientMobilephone", shipmentInfo?.recipientMobilephone ?? "")
                    // 발송지
                    setValue("_new_l_address_value", shipmentInfo?.shippingAddress ?? "")
                    setValue("address1", shipmentInfo?.address1 ?? "");
                    setValue("address2", shipmentInfo?.address2 ?? "");
                    setValue("addressName", shipmentInfo?.addressName ?? "");
                    // 계산서 담당자
                    setValue("newLInvoiceAgentValue", shipmentInfo?.taxInvoicePerson ?? "")
                    setValue("taxCharge", shipmentInfo?.taxChargeName ?? "")
                    setValue("taxContact", shipmentInfo?.taxChargeMobilePhone ?? "")
                    setValue("taxEmail", shipmentInfo?.taxChargeEmailAddress ?? "")
                    // 기타사항(거래명세서 비고)
                    setValue("newTxtNote", shipmentInfo?.newTxtNote ?? "")
                    // 수금메모(세금계산서 비고)
                    setValue("newTxtCollection", shipmentInfo?.newTxtCollection ?? "")
                    // 마감구분
                    setValue("endType", shipmentInfo?.endType ?? "1")
                    // 수금예정일
                    setValue("newDtEstimatedCollection", adjustToValidDateWithMoment(shipmentInfo?.expectedReceiptDate ?? ""))
                }
            }
        })
    }

    const {mutateAsync: mutateAsyncAccountShipmentInfo} = useReadAccountShipmentInfo();
    const setOrdersDetailInit = (data: any, setValue: UseFormSetValue<OrdersCreateType | OrdersDetailType>) => {
        // 수주고객
        setValue("newLContactValue", data.newLContactValue)
        setValue("contactName", data.contactName)
        // 고객사
        setValue("newLEnduserValue", data.newLEnduserValue ?? "");
        setValue("enduserName", data.enduserName ?? "");
        // 수신자
        setValue("_new_l_recipient_value", data.newLRecipientValue)
        setValue("recipientName", data.recipientName)
        setValue("recipientMobilephone", data.recipientMobile)
        // 계산서담당자
        setValue("newLInvoiceAgentValue", data.newLInvoiceAgentValue)
        setValue("taxCharge", data.taxCharge)
        setValue("taxContact", data.taxMobile)
        setValue("taxEmail", data.taxEmail)
        // 발송요청일
        setValue("newDtRequestShipment", data.newDtRequestShipment)
        // 수금메모
        setValue("newTxtCollection", data.newTxtCollection)
        setValue("purchaseOrderId", data.purchaseOrderId)
        // 발송방법
        setValue("newPShipment", data.newPShipment)
        setValue("newPShipmentName", data.newPShipmentName)
        // 결제방법
        // setValue("newPPayment", data.newPPayment)
        // 발송지
        setValue("_new_l_address_value", data.newLAddressValue)
        setValue("addressName", data.addressName)
        setValue("address1", data.address1)
        setValue("address2", data.address2)
        // 고객메모
        setValue("customerMemo", data.customerMemo)
        // 수금예정일
        setValue("newDtEstimatedCollection", data.newDtEstimatedCollection)

        mutateAsyncAccountShipmentInfo({
            accountId: data.newLEnduserValue,
            chargeName: "",
            name: "",
            defaultContact: "",
            customerCategoryName: "",
            industryName: "",
        }).then(r => {
            const shipmentInfo = r.result;

            // 담당자
            setValue("owneridValue", shipmentInfo?.contactPerson ?? '')
            setValue("owningUserName", shipmentInfo?.contactPersonName ?? '')

            // 메모
            setValue("newTxtMemo", shipmentInfo?.memo ?? '')

            // 기타사항(거래명세서 비고)
            setValue("newTxtNote", shipmentInfo?.newTxtNote ?? '')

            // 마감 구분
            setValue("endType", shipmentInfo?.endType ?? '')

            // 납품처
            setValue("newLShipToValue", shipmentInfo?.deliveryPlace ?? '')
            setValue("shipToName", shipmentInfo?.deliveryPlaceName ?? '')

            // 매출처
            setValue("newLCustomerValue", shipmentInfo?.salesPlace ?? '')
            setValue("customerName", shipmentInfo?.salesPlaceName ?? '')

            // 수주 유형
            setValue("_new_l_order_type_m_value", shipmentInfo?.orderType ?? '')

            // Vat 구분
            setValue("_new_l_vat_value", shipmentInfo?.vatType ?? '')

            // 산업 구분
            setValue("newLIndustryValue", shipmentInfo?.industryCategory ?? '')

            // Application
            setValue("newLApplicationValue", shipmentInfo?.application ?? '')

            // 수금메모(세금계산서 비고)
            setValue("newTxtCollection", shipmentInfo?.newTxtCollection ?? '')
        })
    }

    const setOrdersSubjectInit = (data: any, setValue: UseFormSetValue<OrdersCreateSubjectType>) => {
        setValue("list", data.map((el: PcsSubjectElementType) => {
            return {
                ...ordersCreateSubjectElementInit,
                _new_l_erp_product_value: el.newLErpProductValue,
                _new_l_product_group_value: el.newProductGroupid,
                productGroupName: el.productGroupName ?? el.productRange,
                newTxtNmItem: el.productName,
                new_i_qty: el.newIQty,
                new_txt_standard: el.newTxtStandard,
            }
        }))
    }

    return {setContact, setAccount, setOrdersDetailInit, setOrdersSubjectInit}
}